/**
 * Shared types used across the API and web frontend.
 */
/**
 * Steps may embed `{{ing:<id>}}` tokens pointing at an ingredient in the same
 * recipe; the detail view renders them as the ingredient's live-scaled amount.
 * A factory rather than a shared constant: the `g` flag makes RegExp stateful
 * (lastIndex), so a shared instance would corrupt concurrent callers.
 */
export function createIngredientRefRegex() {
    return /\{\{ing:([A-Za-z0-9-]{1,36})\}\}/g;
}
/** The step-text token that references an ingredient by id. */
export function formatIngredientRef(id) {
    return `{{ing:${id}}}`;
}
/**
 * The fixed recipe vocabularies, shared so the web UI's filter/select options
 * and the API's admin write-path validation can never drift apart (the DB
 * stores these as free TEXT and relies on the write path to enforce them).
 * Cuisine and meat are NOT here: those lists grew a "+ add new" affordance, so
 * they live in the recipe_tags table and arrive via the recipeTags query.
 * Typed as `readonly string[]` on purpose: the categories are open-ended data,
 * not a union the type system should propagate.
 */
export const RECIPE_MEALS = ['Breakfast', 'Lunch', 'Dinner', 'Snack', 'Dessert'];
export const RECIPE_DIFFICULTIES = ['Easy', 'Medium', 'Hard'];
export const RECIPE_TAG_KINDS = ['cuisine', 'protein'];
/** Highest spice level; `Recipe.spice` ranges 0..RECIPE_SPICE_MAX (DB CHECK mirrors this). */
export const RECIPE_SPICE_MAX = 4;
/** Display names for each spice level, indexed by `Recipe.spice`. */
export const RECIPE_SPICE_LABELS = [
    'No heat',
    'Mild',
    'Medium',
    'Hot',
    'Very hot',
    'Extreme',
];
export const RECIPE_STATUSES = ['draft', 'complete'];
//# sourceMappingURL=index.js.map